import { combineReducers } from 'redux';
import app from './App/reducer';
import activeGame from './ActiveGame/reducer';
import attackButton from './AttackButton/reducer';
import card from './Card/reducer';
import cards from './Cards/reducer';
import coins from './Coins/reducer';
import confirmButton from './ConfirmButton/reducer';
import deck from './Deck/reducer';
import decks from './Decks/reducer';
import gameStart from './GameStart/reducer';
import games from './Games/reducer';
import gameLog from './GameLog/reducer';
import hand from './Hand/reducer';
import login from './Login/reducer';
import passButton from './PassButton/reducer';
import pokemon from './Pokemon/reducer';
import prizes from './Prizes/reducer';
import passwordReset from './PasswordReset/reducer';
import retreatButton from './RetreatButton/reducer';
import rules from './Rules/reducer';
import picks from './Picks/reducer';
import push from './Push/reducer';
import trainer from './Trainer/reducer';
import users from './Users/reducer';
import { LOGOUT } from './Login/constants';

const appReducer = combineReducers({
  // core reducers (not to reset with APP_RESET)
  app,
  login,

  // reducers to reset with APP_RESET
  activeGame,
  attackButton,
  card,
  cards,
  coins,
  confirmButton,
  deck,
  decks,
  gameStart,
  games,
  gameLog,
  hand,
  passButton,
  pokemon,
  prizes,
  passwordReset,
  retreatButton,
  rules,
  picks,
  push,
  trainer,
  users,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined; // reset the app state
  }
  return appReducer(state, action);
};

export default rootReducer;
